


















import { defineComponent, PropType } from "@vue/composition-api";
import { MediaConstraints } from "@/types";
import MobileSwitchCam from "@/components/MobileSwitchCam";
import Share from "@/components/Share";
import SwitchMicrophone from "@/components/SwitchMicrophone";

export default defineComponent({
  name: "ControlButtons",
  components: {
    SwitchMicrophone,
    MobileSwitchCam,
    Share,
  },
  props: {
    produce: { type: Boolean, required: true },
    stream: { type: MediaStream },
    constraints: { type: Object as PropType<MediaConstraints> },
  },
});
